import { PlayerApiError } from '@/scenarios/legacy-player/types/instance';

export const playerErrors = {
    internalError: (error: PlayerApiError) => `Internal player error: ${error.message}`,
    loadingError: (error: PlayerApiError) => `Error while loading the player: ${error.code}`,
};
